import { Pipe, PipeTransform } from '@angular/core';
import {INTEGRATION_TASKS_FA_CLASS} from '@app/views/admin/application-settings/models/integration.model';

@Pipe({
    name: 'ngcEntityIcon'
})
export class EntityIconPipe implements PipeTransform {

    transform(edutoneEntity: string): string {
        return INTEGRATION_TASKS_FA_CLASS[edutoneEntity]
            ? INTEGRATION_TASKS_FA_CLASS[edutoneEntity]
            : '';
    }

}
